import "./editProfileStyles.css";
import { useAddress } from "@thirdweb-dev/react";
import { useState} from "react";
import { useParams } from "react-router-dom";
import { lensClient } from "../../client/LensClient";
import { isRelaySuccess } from "@lens-protocol/client";
import { ethers } from "ethers";
import { uploadIpfs } from "../../ipfs";
import { toast} from 'react-toastify';
import { v4 as uuidv4 } from "uuid";

export default function EditProfile() {

    const {id} = useParams();
    const ide = id;
    const address = useAddress();
    const [formInput, setFormInput] = useState({
        name:"",
        bio:"",
        location:"",
        twitter:"",
        coverImage:null,
      });

    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();

      // v1 method for edit profile and setting metadata

//       useEffect(()=>{
//         async function details(){
//           if(data){ 
//           const result = data.createSetProfileMetadataTypedData;
//           const typedData = result.typedData;
//           if (!sdk) return;
//           //Sign the typed data using the SDK
//           const signature = await signTypedDataWithOmmittedTypename(sdk,typedData.domain, typedData.types, typedData.value)
//           const { v, r, s } = splitSignature(signature.signature);
//           //Send the typed data to the smart contract to perform the
//           // write operation on the blockchain
//           const lensPeripheryContract = await sdk.getContractFromAbi(
//             LENS_PERIPHERY_ADDRESS,
//             LENS_PERIPHERY_ABI
//           );
//           console.log(lensPeripheryContract);
//           // Call the smart contract function called "followWithSig"
//           const tx = await lensPeripheryContract.call("setProfileMetadataURIWithSig",{
//             profileId: typedData.value.profileId,
//             metadata: typedData.value.metadata,
//             sig: {
//               v,
//               r,
//               s,
//               deadline: typedData.value.deadline,
//             },
//           });
//           toast.info("Changes Saved Successfully.",{
//             position:toast.POSITION.TOP_CENTER
//            })
//       }
//     else{
//         console.log("no data");
//     }
//     }
//     details();
// })

      const UploadMedia = async()=>{
        const fileInput = document.getElementById('cover');
        const fileCID = await uploadIpfs(fileInput.files[0]);
        if(fileCID){
          toast.success("File Uploaded Successfully.", {
          position: toast.POSITION.TOP_CENTER
        });
      }
        const url = `https://ipfs.io/ipfs/${fileCID}`

      setFormInput({
        ...formInput,
        coverImage: url
      })
    }

    const postMetadata = (
      JSON.stringify({
      version: "1.0.0",
      metadata_id: uuidv4(),
      name: formInput.name,
      bio: formInput.bio,
      cover_picture: formInput.coverImage,
      attributes: [{
        key:"Location",
        value:formInput.location
      },
      {
        key:"Website",
        value:formInput.twitter
      }],
    })
    );

    async function uploadMetadata(){
     
      const metaCID = await uploadIpfs(postMetadata);
      return `https://ipfs.io/ipfs/${metaCID}`;
    }

    // const [CreatePublicSetProfileMetadataURIRequest, {data,loading,error}] = useMutation(
    //     SET_PROFILE_METADATA,
    //     {
    //       onCompleted: () => {
    //         console.log("Successful")
    //       },

    //       onError: (error) => {
    //         console.log("Metadata error.", error);
    //       },
    //     }
    //   );
 
      async function HandleDetails(){    
        if (formInput.name==="") {
          toast.warn("Name Field is Empty!!",{
            position:toast.POSITION.TOP_CENTER
          })
        }
        else if (formInput.bio==="") {
          toast.warn("Bio Field is Empty!!",{
            position:toast.POSITION.TOP_CENTER
          })
        }
        else if (!formInput.coverImage) {
          toast.warn("Upload Your Cover Image!!",{
            position:toast.POSITION.TOP_CENTER
          })
        }
        else{
          const postMetadataIpfsUrl = await uploadMetadata();
          const { id, text } = await lensClient.authentication.generateChallenge({
            signedBy:address,
            for: ide, // e.g "0x01"
          });
          const signature = await signer.signMessage(text); // text returned from authentication.generateChallenge
          await lensClient.authentication.authenticate({ id:id, signature:signature});
         
          // your LensClient instance must be authenticated

          const typedDataResult = await lensClient.profile.createSetProfileMetadataTypedData({
            metadataURI: postMetadataIpfsUrl,
          })
          const data = typedDataResult.unwrap()

          // sign with the wallet
          const signedTypedData = await signer._signTypedData(data.typedData.domain,data.typedData.types,
            data.typedData.value)

          // broadcast
          const broadcastResult = await lensClient.transaction.broadcastOnchain({id: data.id,
            signature: signedTypedData,})

          // broadcastResult is a Result object
          const broadcastResultValue = broadcastResult.unwrap()

          if (!isRelaySuccess(broadcastResultValue)) {
            toast.info("Something went wrong",{
              position:toast.POSITION.TOP_CENTER
            })
            console.log(`Something went wrong`, broadcastResultValue)
            return
          }

          // or wait till transaction is indexed
          await lensClient.transaction.waitUntilComplete({forTxId: broadcastResultValue.txId,})
          toast.success("Profile Edited Successfully",{
            position:toast.POSITION.TOP_CENTER
          })

        }
      }

    return(
            <div className="box">
             <div className="publishform">
                <div className="name-div">
                    <p>Name</p>
                <input name="name" onChange={
                    (prop) => setFormInput({
                        ...formInput,
                        name: prop.target.value
                    })
                    } placeholder="Name" required/>
                </div>
              <div className="name-div">
                <p>Bio</p>
                <input name="bio" onChange={
                    (prop) => setFormInput({
                      ...formInput,
                      bio: prop.target.value
                    })
                  } placeholder="Bio" required/>
              </div>
              <div className="name-div">
                <p>Location</p>
                <input name="location" onChange={
                    (prop) => setFormInput({
                      ...formInput,
                      location: prop.target.value
                    })
                  } placeholder="Location" required/>
              </div>
              <div className="name-div">
                <p>Twitter/Website</p>
                <input name="twitter" onChange={
                  (prop) => setFormInput({
                      ...formInput,
                      twitter: prop.target.value
                    })
                  } placeholder="Twitter" required/>
              </div>
            <div className="Upload">
            <div className="cover-div">
                <p>Cover Image</p>
                <div className="dotted-div">
                  <div className="top">
                    <input className="uploadCover" type="file" id="cover" onChange={UploadMedia}/>
                  </div>
                </div>
              </div>
            </div>
            <div className="btn">
              <button className="submit" onClick={HandleDetails}>Submit</button>
            </div>
        </div>
        </div>
    );
}